var jobList = function() {
  const dur = 0.35;
  var checker = exists('.job_openings');

  const mapBlob = {
    all: `<svg width="114" height="56" viewBox="0 0 114 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.86 5.48756C41.1998 -4.50476 92.2276 2.67256 103.032 9.85927C113.836 17.046 121.015 33.2088 102.052 51.1936C94.128 58.7086 76.4033 54.46 56.0571 54.4993C35.3319 54.5393 11.9898 58.6881 4.89409 46.6829C-1.14639 36.463 -3.17153 13.7112 16.86 5.48756Z" fill="currentColor"/>
</svg>`,
    'customer-success': `<svg width="250" height="55" viewBox="0 0 250 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M232.5 2.23138C170.893 2.23193 34.8345 -2.99278 14.5019 4.74832C-5.83079 12.4894 -4.56032 53.4991 16.9147 53.6865C38.3898 53.8739 52.6369 53.9553 105.03 53.0079C158.399 52.0428 211.718 62.5345 240.506 51.1977C258.348 44.1714 248.377 2.23138 232.5 2.23138Z" fill="currentColor"/>
</svg>`,
    engineering: `<svg width="188" height="52" viewBox="0 0 188 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5019 50.7401C63.6647 48.8807 162.988 55.1699 178.823 47.9061C194.658 40.6422 188.819 3.80084 170.341 3.33712C140.584 2.59032 143.661 2.7092 104.419 3.08341C64.4466 3.46461 37.4924 -2.36467 14.1527 2.37239C-4.12066 7.15999 -6.42439 50.7401 17.5019 50.7401Z" fill="currentColor"/>
</svg>`,
    'future-openings': `<svg width="250" height="55" viewBox="0 0 250 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M226.895 53.9954C165.955 51.9967 34.5695 57.0417 13.8145 53.9954C-2.78073 48.5475 -7.4553 3.26701 16.9376 2.76855C56.221 1.9658 60.3502 2.3663 112.154 2.76855C164.923 3.1783 200.505 -3.08768 231.317 2.00426C255.44 7.15052 258.481 53.9954 226.895 53.9954Z" fill="currentColor"/>
</svg>`,
    marketing: `<svg width="180" height="55" viewBox="0 0 180 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.3113 0.811531C65.8419 3.7979 155.844 -0.581871 169.675 7.40032C183.505 15.3825 186.12 53.8932 159.227 54.011C132.333 54.1287 135.117 54.0728 99.7372 52.801C63.6985 51.5055 39.0152 57.0231 18.2557 51.5261C-5.5371 45.226 -7.75269 -1.49412 24.3113 0.811531Z" fill="currentColor"/>
</svg>`,
    operations: `<svg width="165" height="55" viewBox="0 0 165 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M151.5 2.02177C112.642 2.02232 26.8242 -3.16941 13.9995 4.52283C1.17484 12.2151 -9.61217 52.8065 15.5214 53.1521C40.655 53.4977 38.0529 53.4192 71.0994 52.4778C104.762 51.5188 127.897 57.1292 147.228 51.9282C169.384 45.9672 169.566 3.29232 151.5 2.02177Z" fill="currentColor"/>
</svg>`,
    'people-operations': `<svg width="236" height="65" viewBox="0 0 236 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M231.797 14.4646C227.9 8.77783 221.811 7.30293 216.398 6.55225C209.79 5.66398 203.088 5.48347 196.44 5.22942C164.475 4.13578 132.448 4.68453 100.464 4.48704C99.1595 4.49655 97.8826 4.46927 96.5784 4.47878C82.2899 4.36039 67.8998 4.01568 53.5751 4.3448C41.0608 4.63788 28.5134 3.99632 15.9994 5.52218C5.83346 6.76198 -0.377372 17.2013 1.38964 31.6589C2.29416 39.1496 3.74931 47.0256 7.59556 52.5992C12.6804 59.9924 17.5 59.5 26 59.5C57.0363 59.4121 90.1261 57.1273 122 57.5092C154.703 57.9386 187.349 56.812 219.993 57.5092C226.005 57.6376 230.506 52.5038 232.535 44.7021C234.738 36.2692 236.861 24.0988 232.876 16.2808C232.544 15.6386 232.184 15.0332 231.797 14.4646Z" fill="currentColor"/>
</svg>`, 
    product: `<svg width="168" height="57" viewBox="0 0 168 57" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M143.911 0.979778C105.261 4.98984 20.9682 3.07412 8.43918 11.2391C-4.08982 19.4041 -4.64522 57.112 20.4838 56.5204C45.6128 55.9288 43.0096 55.9473 75.998 53.7747C109.601 51.5616 132.93 56.3056 152.054 50.3876C173.972 43.6048 173.752 -2.11623 143.911 0.979778Z" fill="currentColor"/>
</svg>`,
  };

  if (!checker) {
    return;
  }

  var component = document.getElementsByClassName('job_openings')[0],
    container = component.getElementsByClassName('flex_container')[0],
    lever = component.getElementsByClassName('lever')[0],
    postsContainer = null,
    tabsContainer = null,
    activeFilter = 'all',
    tl = new window.TimelineLite(),
    itemHeight = [];

  //fetch data from api
  var apiCall = function() {
    const url =
      'https://api.lever.co/v0/postings/geckoboard?group=team&mode=json';

    var loadingContainer = document.createElement('div');
    loadingContainer.classList.add('loading');
    loadingContainer.innerHTML = 'Loading...';
    container.appendChild(loadingContainer);

    fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(response) {
        component.getElementsByClassName('loading')[0].remove();
        loadDOM(response);
        filterPosts("all");

        var btns = component.getElementsByClassName('lever-tabs__category');
        for (var i = 0; i < btns.length; i++) {
          btns[i].addEventListener('click', function() {
            filterPosts(this.parentElement.getAttribute('data-category'));
          });
        }
      });
  };

  //toggle class helper
  const toggleClass = (el, cls) => {
    el.classList.toggle(cls);
  };

  //create new tab filter
  var newTab = function(name, activeClass) {
    var li = document.createElement('li');
    li.setAttribute('data-category', slugify(name));
    if (activeClass) {
      li.classList.add('active');
    }
    tabsContainer.appendChild(li);

    var btn = document.createElement('button');
    toggleClass(btn, 'lever-tabs__category');
    toggleClass(btn, `lever-category`);
    toggleClass(btn, `lever-category--${slugify(name)}`);

    var blob = document.createElement('span');
    var stronk = document.createElement('strong');
    blob.setAttribute("aria-hidden", true);
    blob.innerHTML = mapBlob[slugify(name)];
    stronk.innerHTML = name;
    btn.appendChild(blob);
    btn.appendChild(stronk);
    li.appendChild(btn);
  };

  //create new post
  var newPost = function(categoryData, postData) {
    var fragment = document.createDocumentFragment();
    var post = document.createElement('a');
    var postWrapper = document.createElement('div');
    
    post.href = postData.hostedUrl;
    post.target = '_blank';
    toggleClass(post, 'lever-post');
    toggleClass(postWrapper, 'lever-post__wrapper');
    postWrapper.setAttribute('data-category', slugify(categoryData.title));
    fragment.appendChild(postWrapper);
    postWrapper.appendChild(post);

    var title = document.createElement('h5');
    toggleClass(title, 'heading--md');
    toggleClass(title, 'lever-post__heading');
    title.innerHTML = postData.text;
    post.appendChild(title);

    var location = document.createElement('p');
    toggleClass(location, 'text--lg');
    toggleClass(location, 'lever-post__description');
    toggleClass(title, 'lever-post__location');
    location.innerHTML =
      postData.categories.commitment + ', ' + postData.categories.location;
    post.appendChild(location);

    var category = document.createElement('div');
    toggleClass(category, 'lever-post__category');
    toggleClass(category, `lever-category`);
    toggleClass(category, `lever-category--${slugify(categoryData.title)}`);

    var blob = document.createElement('span');
    var stronk = document.createElement('strong');
    blob.setAttribute("aria-hidden", true);
    blob.innerHTML = mapBlob[slugify(categoryData.title)];
    stronk.innerHTML = categoryData.title;

    category.appendChild(blob);
    category.appendChild(stronk);
    post.appendChild(category);

    postsContainer.appendChild(postWrapper);
  };

  var loadDOM = function(data) {
    //create container element for tabs
    tabsContainer = document.createElement('ul');
    toggleClass(tabsContainer, 'lever-tabs__container');
    lever.appendChild(tabsContainer);

    //create container element for posts
    postsContainer = document.createElement('div');
    toggleClass(postsContainer, 'lever-posts__container');
    lever.appendChild(postsContainer);

    //create a tab for all posts
    newTab('All', true);

    for (var i = 0; i < data.length; i++) {
      var posts = data[i].postings;
      newTab(data[i].title);

      for (var ii = 0; ii < posts.length; ii++) {
        newPost(data[i], posts[ii]);
      }
    }
  };

  var filterPosts = function(newFilter) {
    if (newFilter == activeFilter || newFilter == 'all') {
      $('.lever-post__wrapper').addClass('active');
      $('.lever-post__wrapper').fadeIn(100);
      $('.lever-tabs__container li').removeClass('active');
      $('.lever-tabs__container li[data-category=all]').addClass('active');
      activeFilter = 'all';
    } else {
      var allPosts = $('.lever-post__wrapper');
      for (var i = 0; i < allPosts.length; i++) {
        if ($(allPosts[i]).attr('data-category') != newFilter) {
          $(allPosts[i]).removeClass("active");
          $(allPosts[i]).fadeOut(100);
        } else {
          $(allPosts[i]).fadeIn(100);
        }
      }
      $('.lever-tabs__container li').removeClass('active');
      $('.lever-tabs__container li[data-category=' + newFilter + ']').addClass(
        'active',
      );
      activeFilter = newFilter;
    }
  };

  apiCall();
};

window.addEventListener('load', function() {
  jobList();
});
